import ExportFieldLabel from './ExportFieldLabel'
import ExportFormatSection from './ExportFormatSection'
import ExportHoverTooltip from './ExportHoverTooltip'
import ExportReportDataSection from './ExportReportDataSection'
import { EXPORT_REPORT_SETTINGS_TOOLTIPS } from './exportReportSettingsTooltips'

export default function ExportReportSettingsForm({
  includeTemplate = false,
  exportName,
  defaultReportName,
  onExportNameChange,
  exportFormat,
  onExportFormatChange,
  reportDataScope,
  onReportDataScopeChange,
  exportTemplateRef,
  exportTemplateOpen,
  onExportTemplateOpenChange,
  exportSourceTemplateId,
  reportTemplates = [],
  onApplyExportTemplate,
}) {
  const templateLabel = exportSourceTemplateId
    ? (reportTemplates.find((t) => t && t.id === exportSourceTemplateId)?.name ?? 'Custom')
    : 'Blank Report'

  return (
    <div className="dashboardExportSummary">
      {includeTemplate && (
        <div className="dashboardExportFormSection">
          <div className="dashboardExportFieldRow">
            <div className="dashboardExportField">
              <ExportFieldLabel tooltip={EXPORT_REPORT_SETTINGS_TOOLTIPS.template}>
                Template
              </ExportFieldLabel>
              <div ref={exportTemplateRef} className="dashboardFilterSelect dashboardExportSelect dashboardExportFieldSelectWrap">
                <button
                  className="dashboardExportFieldSelect"
                  type="button"
                  onClick={() => onExportTemplateOpenChange((open) => !open)}
                  aria-expanded={exportTemplateOpen}
                  aria-haspopup="listbox"
                >
                  <span className="dashboardExportFieldSelectValue">{templateLabel}</span>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                    <path d="M6 9l6 6 6-6" />
                  </svg>
                </button>
                {exportTemplateOpen && (
                  <div className="dashboardFilterSelectMenu dashboardExportTemplateMenu">
                    {reportTemplates.filter((t) => t && t.id !== 'blank').map((t) => (
                      <button
                        key={t.id}
                        type="button"
                        className="dashboardFilterSelectOption"
                        onClick={() => onApplyExportTemplate(t.id)}
                      >
                        <span className="dashboardExportTemplateName">{t.name}</span>
                        <span className="dashboardExportTemplateDesc">{t.description}</span>
                      </button>
                    ))}
                    <div className="dashboardExportTemplateDivider" role="separator" />
                    <button
                      type="button"
                      className="dashboardFilterSelectOption"
                      onClick={() => onApplyExportTemplate('blank')}
                    >
                      Blank Report
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="dashboardExportFormSection">
        <div className="dashboardExportField dashboardExportField--full">
          <ExportFieldLabel htmlFor="export-report-name" tooltip={EXPORT_REPORT_SETTINGS_TOOLTIPS.reportName}>
            Report name
          </ExportFieldLabel>
          <ExportHoverTooltip
            as="input"
            content={EXPORT_REPORT_SETTINGS_TOOLTIPS.reportName}
            id="export-report-name"
            className="dashboardExportInput"
            type="text"
            value={exportName}
            placeholder={defaultReportName}
            onChange={onExportNameChange}
          />
        </div>
      </div>
      <div className="dashboardExportFormSection dashboardExportFormSection--last">
        <div className="dashboardExportFieldRow dashboardExportFieldRow--segmented">
          <ExportFormatSection value={exportFormat} onChange={onExportFormatChange} />
          <ExportReportDataSection value={reportDataScope} onChange={onReportDataScopeChange} />
        </div>
      </div>
    </div>
  )
}
